export interface CortexPrompt {
  id: string;
  label: string;
  text: string;
  /**
   * Telemetry source. Preserved as `patient-snapshot:<id>` for analytics
   * continuity even though the prompts now surface under multiple tabs.
   */
  source: string;
}

const CORTEX_PROMPT_SOURCE = 'patient-snapshot';

function cortexPromptSource(id: string): string {
  return `${CORTEX_PROMPT_SOURCE}:${id}`;
}

export const CORTEX_PROMPTS: readonly CortexPrompt[] = [
  {
    id: 'lab-trends',
    label: 'Lab trends',
    text: "Summarize this patient's recent lab trends and call out any abnormal results.",
    source: cortexPromptSource('lab-trends'),
  },
  {
    id: 'active-conditions',
    label: 'Active conditions',
    text: "List this patient's active conditions with the most relevant clinical context.",
    source: cortexPromptSource('active-conditions'),
  },
  {
    id: 'active-meds',
    label: 'Active meds',
    text: "List this patient's active medications, including dose, frequency, and any concerns.",
    source: cortexPromptSource('active-meds'),
  },
  {
    id: 'message-patient',
    label: 'Message patient',
    text: 'Draft a message to this patient checking in on their current concerns.',
    source: cortexPromptSource('message-patient'),
  },
];
